import React from 'react';
import BaseParametroCrud from './BaseParametroCrud';

export default function TipoQuienBrindaInfo() {
    return (
        <BaseParametroCrud
            header={{
                title: 'Tipos de Quien Brinda Info',
                idCabezaFamilia: '1',
                url: '/parametros',
                nombreurl: 'Parámetros',
                nombreform: 'Tipos de Quien Brinda Info'
            }}
            formTitle="Formulario tipos de quien brinda info"
            loadUrl="/parametros/tipoquienbrindainfo"
            saveUrl="/parametros/guardartipoquienbrindainfo"
            alertTitle="Guardar tipos de quien brinda info"
            defaultValues={{
                id: 0,
                strNombre: '',
                bolActivo: false
            }}
            mapRowToForm={(row) => ({
                id: row.id,
                strNombre: row.strNombre,
                bolActivo: row.bolActivo
            })}
            columns={[
                { key: 'id', title: 'Id' },
                { key: 'strNombre', title: 'Nombre' },
                {
                    key: 'bolActivo',
                    title: 'Estado',
                    render: (row) => (row.bolActivo ? 'Activo' : 'Inactivo')
                }
            ]}
            renderFormFields={({ register, errors }) => (
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="strNombre">Nombre</label>
                                <input
                                    {...register('strNombre', { required: true })}
                                    className="form-control"
                                    placeholder="Nombre"
                                    id="strNombre"
                                />
                                {errors.strNombre && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolActivo')}
                                        className="custom-control-input"
                                        id="SwitchEstado"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}